if (!customElements.get('fomo-countdown-timer')) {
  customElements.define(
    'fomo-countdown-timer',
    class FomoCountdownTimer extends HTMLElement {
      constructor() {
        super();
        const id = this.id;
        this.date = new Date(this.dataset.startdate);
        const _this = this;
        if(this.distance() > 0) this.interval = setInterval(function(){ _this.countdown(_this); },1000);
      }

      distance(){
        const cdDate = this.date.getTime();
        const now = new Date().getTime();
        return cdDate - now;
      }

      findAndSetValue(id,value){
        const element = this.querySelector(id);
        if(element) element.innerText = value;
      }

      countdown(_this){
        const distance = _this.distance();
        if(distance <= 0) clearInterval(_this.interval);
        else{
          _this.findAndSetValue("#timer-sec", Math.floor((distance / 1000) % 60));
          _this.findAndSetValue("#timer-min", Math.floor((distance / 1000 / 60) % 60));
          _this.findAndSetValue("#timer-hrs", Math.floor((distance / (1000 * 60 * 60)) % 24));
          _this.findAndSetValue("#timer-day", Math.floor(distance / (1000 * 60 * 60 * 24)));
        }
      }
    }
  );
}